const avatarColors = {
  student: ['orange', 'green', 'yellow', 'pink'],
  teacher: ['blue', 'indigo', 'green', 'purple'],
} as const;

/** 按稳定身份分配色组，避免排序、筛选或刷新改变同一个人的头像底色。 */
export function getFallbackAvatarBackground(id: string, kind: keyof typeof avatarColors): string {
  const hash = Array.from(id).reduce((value, character) => (Math.imul(value, 31) + character.charCodeAt(0)) >>> 0, 0);
  const colors = avatarColors[kind];
  return `var(--color-avatar-${kind}-${colors[hash % colors.length]})`;
}

/** 获取头像文字颜色：学员使用深色文字（color.avatar.foreground），老师使用反白文字（color.avatar.teacher-foreground）。 */
export function getFallbackAvatarTextColor(kind: keyof typeof avatarColors): string {
  return kind === 'teacher' ? 'var(--color-avatar-teacher-foreground)' : 'var(--color-avatar-foreground)';
}

